<template>
  <section>
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">レポート作成</p>
      </header>

      <section class="modal-card-body main">
        <form @submit.prevent="submit">
          <b-field
            label="レポート名"
            :type="{'is-danger': errors.has('newReport')}"
            :message="errors.first('newReport')">
            <b-input
              name="newReport"
              data-vv-as="レポート名"
              v-model="name"
              maxlength="64"
              size="is-medium"
              v-validate="'required'"/>
          </b-field>
        </form>
      </section>

      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">キャンセル</button>
        <button class="button is-primary" @click="submit">作成</button>
      </footer>
    </div>
  </section>
</template>

<script>
import snackbar from "@/shared/snackbar";

export default {
  data() {
    return {
      name: "",
    };
  },
  methods: {
    submit() {
      this.$validator.validateAll().then( async (result) => {
        if (result) {
          const self = this;
          try {
            const result = await this.$store.dispatch("report/createNewReportGroup", this.name);
            self.$parent.close();
            snackbar.success(this, { message: "レポートを作成しました。"});
          } catch (error) {
            snackbar.error(this, { message: `レポートの作成に失敗しました。: ${error}` });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-card-foot {
  display: flex;
  justify-content: flex-end;
}
.main {
  display: flex;
  flex-direction: column;

  @media screen and (min-width:1024px) {
    min-width: 680px;
  }
}
</style>
